module.exports = __webpack_public_path__ + "img/insure-banner-jp.c8ec5aa.png";